import { api } from "@/shared/libs/axiosClient";
import { ListGrantGroupsResponse, GrantGroupResponse, UpsertGrantGroupRequest, DeleteGrantGroupResponse} from "@/types";


export function listGrantGroups(): Promise<ListGrantGroupsResponse> {
    return api.get<ListGrantGroupsResponse>("/grant-group/list");
}

export function getGrantGroup(id: number): Promise<GrantGroupResponse> {
    return api.get<GrantGroupResponse>(`/grant-group/${id}`);
}

export function createGrantGroup(req: UpsertGrantGroupRequest): Promise<GrantGroupResponse> {
    return api.post<GrantGroupResponse>("/grant-group", req);
}

export function updateGrantGroup(id: number, req: Partial<UpsertGrantGroupRequest>): Promise<GrantGroupResponse> {
    return api.patch<GrantGroupResponse>(`/grant-group/${id}`, req);
}

export function deleteGrantGroup(id: number): Promise<DeleteGrantGroupResponse> {
    return api.delete<DeleteGrantGroupResponse>(`/grant-group/${id}`);
}